import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Functional isn't always better",
  "description": "",
  "published": "2011-10-07T00:00:00.000Z",
  "redirect_from": ["/blog/functional-isnt-always-better/swizec/2591"],
  "categories": "Clojure, Functional programming, JavaScript, Languages, Lisp, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/300px-BDSM_collar_back3.jpg",
        "alt": "A BDSM-style collar that buckles in the back. ...",
        "title": "A BDSM-style collar that buckles in the back. ..."
      }}></img></p>
    <p>{`For a long time now I've been completely in love with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Functional_programming",
        "title": "Functional programming"
      }}>{`functional programming`}</a>{` to the point that I write functional-style code even in run of the mill normal languages.`}</p>
    <p>{`There are many reasons I like functional code, the paper `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.cse.chalmers.se/~rjmh/Papers/whyfp.html"
        }}>{`Why functional programming matters`}</a></em>{`, by John Hughes sums up my opinion perfectly.`}</p>
    <p>{`A few days ago I came upon a problem that killed my idea of functional code being superior and awesome beyond belief. This might have happened because I'm not a very good functional programmer yet, or the tool I was using (javascript) just doesn't support the right things ... but I doubt I would have written it any better in clojure.`}</p>
    <p>{`The problem is one of turning a list of values, say, `}<em parentName="p">{`[`}{`A, B, C, D]`}</em>{` into a list of pairs with itself, like so `}<em parentName="p">{`[`}{`[`}{`A,B], `}{`[`}{`A,C], `}{`[`}{`A,D], `}{`[`}{`B, C], `}{`[`}{`B,D], `}{`[`}{`C,D]].`}</em></p>
    <p>{`Should be simple enough right? You just make another list shifted by one to the left, make a zip, then repeat until the second list is empty. This solution turns out to be horrible, looks ugly and I'm not even going to show it. So here's my second functional solution ... it's a lot cleaner.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function pairs_functional2(data) {
    return _.reduce(_.map(_.range(1, _.size(data)),
                         function (i) {
                             return _.map(_.rest(data, i),
                                          function (item) {
                                              return [data[i-1], item];
                                          });
                         }),
                   function (memo, pairs) {
                       _.map(pairs, function (pair) {
                           memo.push(pair);
                       });
                       return memo;
                   }, []);
`}</code></pre>
    <p>{`A little `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Syntactic_sugar",
        "title": "Syntactic sugar"
      }}>{`syntactic sugar`}</a>{` wouldn't hurt ... writing a lambda in javascript isn't the cleanest of beasts. That final reduce down there also isn't the best of things from a functional standpoint. I don't like that push, but honestly I didn't know how to do that better.`}</p>
    <p>{`Here's an iterative solution for comparison:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function pairs_iterative(data) {
  var out = [];
  for (var i = 0; i < _.size(data); i++) {
    for (var j = i + 1; j < _.size(data); j++) {
      out.push([data[i], data[j]]);
    }
  }
  return out;
}
`}</code></pre>
    <p>{`I haven't looked at performance, but both implementations are functionally the same ... I'm feeling a bit at a loss here. Am I doing something stupid in the first implementation? Or is this just the kind of problem that fits iterative programming better than functional?`}</p>
    <p>{`I'm tempted to do an implementation in clojure just to see if this thing looks so ugly in javascript on account of the syntax ...`}</p>
    <p>{`PS: the original implementation uses underscore.js so it works in all browsers just as the iterative would. Also I don't think javascript natively has enough such functions ... it would be even uglier.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.exampler.com/blog/2011/09/23/further-reading-for-functional-programming-for-object-oriented-programmers/"
        }}>{`Exploration Through Example " Blog Archive " Further reading for "Functional Programming for Object-Oriented Programmers"`}</a>{` (exampler.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://drknucklehead.wordpress.com/2011/10/02/what-is-clojure-who-should-use-it/"
        }}>{`What is Clojure? Who Should Use It?`}</a>{` (drknucklehead.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://drknucklehead.wordpress.com/2011/09/13/its-all-functional/"
        }}>{`It's All Functional?`}</a>{` (drknucklehead.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/koush/node/wiki/%22async%22-support-in-node.js"
        }}>{`Fixing the callback spaghetti in node.js`}</a>{` (github.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sqlserverbiblog.wordpress.com/2011/09/29/using-custom-code-to-synchronize-different-datasets/"
        }}>{`Using Custom Code to Synchronize Different Datasets`}</a>{` (sqlserverbiblog.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5c60557d-32ea-42be-a3e9-35af7702a974",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      